import { Controller } from "stimulus"

export default class extends Controller {
  dismiss() {
    this.element.hidden = true

    const nextNotice = Array.from(this.element.parentElement.querySelectorAll(".markdown-import-notice__item"))
      .find(notice => notice !== this.element && !notice.hidden)
    const nextFocus = nextNotice?.querySelector("button") || document.querySelector(".ProseMirror")

    nextFocus?.focus()
  }
}
